import { ResponsiveContainer as RechartsResponsiveContainer } from 'recharts';

export const ResponsiveContainer = (
    props: React.ComponentProps<typeof RechartsResponsiveContainer>
) => {
    return (
        <RechartsResponsiveContainer
            data-testid={'ResponsiveContainer-container'}
            {...props}
        />
    );
};

export default ResponsiveContainer;
